import { ChangeEvent } from 'react';
import { Box, TextField } from '@mui/material';
import { Match, pipe } from 'effect';

export type LoggerCountLimitProps = {
    minCountLimit: number | undefined;
    setMinCountLimit: (value: number | undefined) => void;
    maxCountLimit: number | undefined;
    setMaxCountLimit: (value: number | undefined) => void;
    isDisabled: boolean;
};

export const LoggerCountLimit = ({
    minCountLimit,
    setMinCountLimit,
    maxCountLimit,
    setMaxCountLimit,
    isDisabled
}: LoggerCountLimitProps) => (
    <Box display="flex" gap="16px">
        <TextField
            type="number"
            value={minCountLimit ?? ''}
            onChange={(e) => setMinCountLimit(parseInputToNumber(e))}
            placeholder="Min Count"
            disabled={isDisabled}
            inputProps={{
                step: 1,
                min: 0
            }}
            sx={{ width: '125px' }}
            size="small"
        />

        <TextField
            type="number"
            value={maxCountLimit ?? ''}
            onChange={(e) => setMaxCountLimit(parseInputToNumber(e))}
            placeholder="Max Count"
            disabled={isDisabled}
            inputProps={{
                step: 1,
                min: 0
            }}
            sx={{ width: '125px' }}
            size="small"
        />
    </Box>
);

const parseInteger = (value: string) => parseInt(value, 10);

const matchNumberOrUndefined = (value: number) =>
    Match.value(value).pipe(
        Match.when(
            (value) => isNaN(value),
            () => undefined
        ),
        Match.orElse((value) => value)
    );

const parseInputToNumber = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    pipe(event.target.value, parseInteger, matchNumberOrUndefined);
